import axiosInstance from './axiosInstance';

export const getStudents = async (params?: {
  page?: number;
  limit?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  class?: string;
  gender?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}) => {
  const response = await axiosInstance.get('/students', { params });
  return response.data;
};

export const getStudent = async (id: string) => {
  const response = await axiosInstance.get(`/students/${id}?include=guardians`);
  return response.data;
};

export const addStudent = async (studentData: {
  firstName: string;
  lastName: string;
  classId?: string;
  status?: string;
}) => {
  const response = await axiosInstance.post('/students', studentData);
  return response.data;
};

export const updateStudent = async (id: string, studentData: any) => {
  const response = await axiosInstance.put(`/students/${id}`, studentData);
  return response.data;
};

export const deleteStudent = async (studentId: string) => {
  const response = await axiosInstance.delete(`/students/${studentId}`);
  return response.data;
};

export const getStudentById = async (studentId: string) => {
  const response = await axiosInstance.get(`/students/${studentId}?include=guardians,fees`);
  return response.data;
};

export const searchStudents = async (search: string) => {
  const response = await axiosInstance.get("/students/search", {
    params: { search, limit: 10 },
  });
  return response.data;
};